import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';
import { useDraftCqrsFind } from '@dreryk/react-draft';

import { getReferralDraftToken } from '../referral.draft';
import { referralTranslationKeys } from '../translations';

import { referralToAnalyticalExaminationDraftSchema } from './referralToAnallyticalExamination.draft';
import { ReferralToAnalyticalExaminationFormBean } from './ReferralToAnalyticalExaminationForm/ReferralToAnalyticalExaminationForm.types';

type ReferralToAnalyticalExaminationPanelChildrenRenderProps = {
   referralToAnalyticalExaminationDraft: ReferralToAnalyticalExaminationFormBean | null;
};

type ReferralToAnalyticalExaminationPanelLoaderProps = {
   readonly visitId: number;
   readonly children: (renderProps: ReferralToAnalyticalExaminationPanelChildrenRenderProps) => JSX.Element;
};

export const ReferralToAnalyticalExaminationPanelLoader = (
   props: ReferralToAnalyticalExaminationPanelLoaderProps
): JSX.Element => {
   const {
      data: referralToAnalyticalExaminationDraft,
      loading: referralToAnalyticalExaminationDraftLoading,
      error: referralToAnalyticalExaminationDraftError,
   } = useDraftCqrsFind(
      {
         token: getReferralDraftToken('referralToAnalyticalExamination', props.visitId),
      },
      referralToAnalyticalExaminationDraftSchema
   );

   if (referralToAnalyticalExaminationDraftLoading) {
      return <LoaderSpinner />;
   }

   if (referralToAnalyticalExaminationDraftError) {
      return (
         <Message
            testId={'referralToAnalyticalExaminationFetchError'}
            type={MessageType.NEGATIVE}
            label={referralTranslationKeys.referralFetchError}
            displayIndicator
         />
      );
   }

   return props.children({
      referralToAnalyticalExaminationDraft: referralToAnalyticalExaminationDraft?.contents ?? null,
   });
};
